/**
 * Reset Preferences Model
 * Defines what fields should be retained after saving a transaction
 */

export interface ResetPreferences {
  keepMember: boolean;          // Keep customer/member/party selected
  keepDate: boolean;            // Keep date picker value
  keepPaymentMode: boolean;     // Keep payment terms (cash/credit/check)
  keepRemarks: boolean;         // Keep notes/remarks/narration
  keepRoute: boolean;           // Keep route/rate list (milk modules)
  keepLineItems: boolean;       // Keep product line items (purchase/sales)
  keepShift: boolean;           // Keep shift selection (milk modules)
  customFields?: string[];      // Module-specific fields
  applyToAll: boolean;          // Apply across sessions (future enhancement)
}

export interface ResetOption {
  key: keyof ResetPreferences;
  label: string;
  description: string;
  icon?: string;
  module?: string;
  labelKey?: string;       // i18n key for label
  descKey?: string;        // i18n key for description
}

/**
 * Module IDs for configuration mapping
 */
export const RESET_MODULE_IDS = {
  MILK_COLLECTION: 'milk-collection',
  MILK_SALE: 'milk-sale',
  PAYMENTS: 'payments',
  RECEIPTS: 'receipts',
  PURCHASES: 'purchases',
  SALES: 'sales',
  GST_PURCHASES: 'gst-purchases',
  GST_SALES: 'gst-sales',
  ROUTE_MILK_RECEIPT: 'route-milk-receipt'
} as const;

/**
 * Default reset preferences - all fields reset (safe default)
 */
export const DEFAULT_RESET_PREFERENCES: ResetPreferences = {
  keepMember: false,
  keepDate: false,
  keepPaymentMode: false,
  keepRemarks: false,
  keepRoute: false,
  keepLineItems: false,
  keepShift: false,
  applyToAll: false
};
